import { IChartConfig, IChartData, ITitle, IBoxAndWhiskerDataPoints, IScatterDataPoints } from './canvas-chart-interfaces';
import { Descriptive } from './../../classes/Descriptive';

export class ChartConfigBuilder implements IChartConfig {
  zoomEnabled: boolean;
  animationEnabled: boolean;
  data: IChartData[];
  title: ITitle;
  rangeChanged?: any;
  type?: string;
  showInLegend?: boolean;
  markerType?: string;
  legendText?: string;

  constructor() { }

  getBaseConfig(): IChartConfig {
    this.animationEnabled = true;
    this.zoomEnabled = true;
    this.showInLegend = true;
    return this;
  }

  addData(data: IChartData[]): IChartConfig {
    this.data = data;
    return this;
  }

  addTitle(title: string): IChartConfig {
    this.title = new Title(title);
    return this;
  }
}

export class Title implements ITitle {
  constructor(public text: string) {
    this.text = text;
  }
}

export class ChartType {
  public static CHART_BOXANDWHISKER = 'boxAndWhisker';
  public static CHART_SCATTER = 'scatter';
}

export class BoxAndWhiskerDataPoints implements IBoxAndWhiskerDataPoints {
  constructor(public x: any, public y: Array<any>, public label?: string) {
    this.x = x;
    this.y = y;
    this.label = label;
  }
}

export class ScatterDataPoint implements IScatterDataPoints {
  constructor(public x: number, public y: number, public label?: string) {
    this.x = x;
    this.y = y;
    this.label = label;
  }
}

export class ChartData implements IChartData {
  constructor(public type: string, public dataPoints: any[]) {
    this.type = type;
    this.dataPoints = dataPoints;
  }
}

export class ChartStatsCalc {
  constructor(public data: any[]) {
    this.data = data.sort((a, b) => Number(a) - Number(b));
  }

  getPercentile(percentile: number): number {
    if (this.data.length === 0) {
      return 0;
    }
    if (typeof percentile !== 'number') {
      throw new TypeError('p must be a number');
    }
    if (percentile <= 0) {
      return this.data[0];
    }
    if (percentile >= 1) {
      return this.data[this.data.length - 1]
    }

    let index = this.data.length * percentile,
      lower = Math.floor(index),
      upper = lower + 1,
      weight = index % 1;

    if (upper >= this.data.length) {
      return this.data[lower];
    }
    return this.data[lower] * (1 - weight) + this.data[upper] * weight;
  }

  getThreeSigmaHigh(): number {
    return Descriptive.mean(this.data) + Descriptive.stdDev(this.data) * 3;
  }

  getThreeSigmaLow(): number {
    return Descriptive.mean(this.data) + Descriptive.stdDev(this.data) * -3;
  }
}
